const $ = require('jquery')


import { CountUp } from 'countup.js';
import { slick } from 'slick-carousel';


document.addEventListener("DOMContentLoaded", function() {
  var lazyVideos = [].slice.call(document.querySelectorAll("video.lazy"));

  if ("IntersectionObserver" in window) {
    var lazyVideoObserver = new IntersectionObserver(function(entries, observer) {
      entries.forEach(function(video) {
        if (video.isIntersecting) {
          for (var source in video.target.children) {
            var videoSource = video.target.children[source];
            if (typeof videoSource.tagName === "string" && videoSource.tagName === "SOURCE") {
              videoSource.src = videoSource.dataset.src;
            }
          }

          video.target.load();
          video.target.classList.remove("lazy");
          lazyVideoObserver.unobserve(video.target);
        }
      });
    });

    lazyVideos.forEach(function(lazyVideo) {
      lazyVideoObserver.observe(lazyVideo);
    });
  }
});


var options = {
  duration: 3,
  useEasing: true,
  useGrouping: true,
  separator: ',',
  decimal: '.'
}

var optionsDecimals = {
  duration: 3,
  useEasing: true,
  useGrouping: true,
  separator: ',',
  decimalPlaces: 1,
  decimal: '.'
}

var optionsDecimals2 = {
  duration: 3,
  useEasing: true,
  useGrouping: true,
  separator: ',',
  decimalPlaces: 2,
  decimal: '.'
}

var optionsDecimalsComma = {
  duration: 3,
  useEasing: true,
  useGrouping: true,
  decimalPlaces: 3,
  separator: ',',
  decimal: ','
}

var optionsDecimalsComma2 = {
  duration: 3,
  useEasing: true,
  useGrouping: true,
  separator: ',',
  decimal: ','
}

var rxrStat1 = $('#rxr-stat1').text();
var rxrStat2 = $('#rxr-stat2').text();
var rxrStat3 = $('#rxr-stat3').text();

var stat1 = new CountUp('rxr-stat1', rxrStat1, options);
var stat2 = new CountUp('rxr-stat2', rxrStat2, options);
var stat3 = new CountUp('rxr-stat3', rxrStat3, options);
// var stat2 = new CountUp('stat2', 0, 10, 0, 5, options)
// var stat3 = new CountUp('stat3', 0, 100, 0, 5, options_plus)

stat1.start();
stat2.start();
stat3.start();










// Select all links with hashes
$('a[href*="#"]')
  // Remove links that don't actually link to anything
  .not('[href="#"]')
  .not('[href="#0"]')
  .click(function(event) {
    // On-page links
    if (
      location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') 
      && 
      location.hostname == this.hostname
    ) {
      // Figure out element to scroll to
      var target = $(this.hash);
      target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
      // Does a scroll target exist?
      if (target.length) {
        // Only prevent default if animation is actually gonna happen
        event.preventDefault();
        $('html, body').animate({
          scrollTop: target.offset().top - 74
        }, 500, function() {
          // Callback after animation
          // Must change focus!
          var $target = $(target);
          $target.focus();
          if ($target.is(":focus")) { // Checking if the target was focused
            return false;
          } else {
            $target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
            $target.focus(); // Set focus again
          };
        });
      }
    }
  });


$( ".mobileHamburger" ).on( "click", function() {
  $('.mobileMenu').toggleClass('hidden');
});

$( ".mlink" ).on( "click", function() {
  $('.mobileMenu').addClass('hidden');;
});


var slideUp = {
    distance: '100px',
    origin: 'bottom',
    delay: 200,
    duration: 600,
    opacity: 0,
    mobile: true
};

var fadeIn = {
    delay: 200,
    duration: 600,
    opacity: 0,
    mobile: true
};

var slideUpNoDelay = {
    distance: '100px',
    origin: 'bottom',
    duration: 600,
    opacity: 0
};

var slideUpInsta = {
    distance: '100px',
    origin: 'bottom',
    delay: 200,
    interval: 100,
    duration: 600,
    opacity: 0,
    mobile: true
};

ScrollReveal().reveal('.slide-up', slideUp);

ScrollReveal().reveal('.fade-in', fadeIn);

ScrollReveal().reveal('.slide-upNoDelay', slideUpNoDelay);






// $( ".featured-brand" ).not('.featured-brand.whats').on( "click", function() {

//   if ($(this).hasClass('active')) {
//     $(this).removeClass('active');
//     $('.dark-overlay').fadeOut(200);

//   } else {
//     $(".featured-brand").removeClass('active');
//     $(this).addClass('active');
//     $('.dark-overlay').fadeIn(200);
//   }


// });


$('.featured-brand').on( "click", function() {
  $('.fm-detail').hide();
  $('.white-arrow').hide();
  $('.' + $(this).attr('id')).slideDown();
  $(this).find('.white-arrow').show();

  $('.first-slider').slick('setPosition'); 

  $('html, body').animate({
        scrollTop: $('.' + $(this).attr('id')).offset().top - 74
    }, 500);


});


$( ".dark-overlay" ).on( "click", function() {
  $(".featured-brand").removeClass('active');
  $('.dark-overlay').fadeOut(200);
});


$('#hamburger').on('click', function (e) {
  $('.mobile-menu').toggleClass('hidden');
});

$('#hamburger-close').on('click', function (e) {
  $('.mobile-menu').toggleClass('hidden');
});

$('.mobile-menu a').on('click', function (e) {
  $('.mobile-menu').toggleClass('hidden');
});





$(document).ready(function(){
  $('.about-slider').slick({
  });


  $('.clients-slider').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 1000,
    arrows: false,
    dots: false,
    focusOnSelect: false,
    pauseOnHover: false,
    pauseOnFocus:false,
    draggable: false,
    swipe: false,
    swipeToSlide: false,
    touchMove: false,
    responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 3
      }
    }]
  });


  $('.first-slider').slick({
  });










const feed = new Instafeed({
        accessToken: InstagramToken,
        limit: 13,
        resolution: 'standard_resolution',
        template: '<div class="w-1/2 lg:w-1/5 px-2 mb-4 flex-auto"><a href="{{link}}" target="_blank" class="slide-upInsta load-hidden insta-link rounded-xl bg-white relative block"><div style="background: #fff url({{image}}) no-repeat; background-position:center; width: 100%; height: 100%; padding-bottom: 100%; background-size: contain;" class="insta-pic relative shadow-lg rounded-xl shadow-md insta-card lg:hover:shadow-xl transition-all"></div></a></div>'
    });
    feed.run();

setTimeout(function(){
$("#instafeed > div:nth-child(6)").after('<div class="w-full lg:flex-auto lg:w-2/5 px-2 mb-4"><a href="https://www.instagram.com/fallenmedia/" target="_blank" class="rounded-xl bg-volt block"><img class="rounded-xl shadow-md" src="/img/fallen-insta.png"></a></div>');
$("#instafeed > div:nth-child(5), #instafeed > div:nth-child(6), #instafeed > div:nth-child(8), #instafeed > div:nth-child(9), #instafeed > div:nth-child(10), #instafeed > div:nth-child(11), #instafeed > div:nth-child(12), #instafeed > div:nth-child(13), #instafeed > div:nth-child(14)").addClass('hidden lg:block');
ScrollReveal().reveal('.slide-upInsta', slideUpInsta);
 }, 1000);



var $nav = $("header, .logo-link");
$nav.toggleClass('scrolled', $(this).scrollTop() > $nav.height());




$(function() {


    // *only* if we have anchor on the url
    if(window.location.hash) {

        // smooth scroll to the anchor id
        $('html, body').animate({
            scrollTop: $(window.location.hash).offset().top - 74
        }, 500);
    }

});


  });





$(function () {
  $(document).scroll(function () {
    var $nav = $("header, .logo-link");
    $nav.toggleClass('scrolled', $(this).scrollTop() > $nav.height());
  });
});












// WEBPACK FOOTER //
// ./assets/js/index.js